const subheadingData = {
  1: [
    {
      title: "About Me",
      content: (
        <>
          <p>
            Hey there! I'm Edward Cooper, a versatile Software Engineer with a
            knack for diving into tasks headfirst. My journey kickstarted in the
            realm of education and customer service, where adaptability and
            precision were my strong suits. Now, transitioning into tech, I'm on
            fire with a newfound passion for crafting innovative solutions to
            real-world challenges through code.
          </p>
        </>
      ),
    },
  ],
  2: [
    {
      title: "Operation Spark",
      content: (
        <>
          <p>
            IBC Fundamentals of Javascript, Functional Programming, and Web
            Development Level 3 - Advanced Software Engineering Immersive
            Program
          </p>
          <span style={{ marginLeft: "10rem" }}>2022-2023</span>
        </>
      ),
    },
  ],
  3: [
    {
      title: "Freelance, Full Stack Developer",
      content: (
        <>
          <p>
            • Delivered mobile and web applications for small business clients, consistently 
            meeting tight deadlines and quality standards.
          </p>
          <p>
            • Managed client expectations and provided ongoing support, 
            ensuring clear and effective communication throughout project lifecycles.
          </p>
          <span style={{ marginLeft: "8rem" }}>Current</span>
        </>
      ),
    },
    {
      title:
        "Young Audiences Charter School, Special Education Paraprofessional & Basketball Coach",
      content: (
        <>
          <p>
            • Fostered communication, leadership, and mentorship through classroom and athletic support.
          </p>
          <p>
            • Demonstrated adaptability and creative problem-solving in high-pressure, team-oriented environments.
          </p>
          <span style={{ marginLeft: "8rem" }}>08/2019 - 07/2022</span>
        </>
      ),
    },
  ],
};

export default subheadingData;
